import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCantidadDiasIngresoFuturoNomina, saveDatosNominales } from "../../../../../redux/actions/nomina";
import { convertDateTimeToNet } from "../../../../../util/datetime";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import DatosNominalesForm from "./DatosNominalesForm";

const initialValues = {
  fechaIngresoEmpleador: null,
  domestica: false,
  bajaNomina: false,
  motivoBaja: "",
  fechaBaja: null,
  categoriaDomestica: "",
  fechaIngresoDependencia: null,
  establecimiento: "",
  puestoTrabajo: "",
  turno: "",
  horaDesde: null,
  horaHasta: null,
};

const DatosNominalesContainer = ({ setLastFormSended, handleCancelNomina }) => {
  const nomina = useSelector((state) => state.nomina.existeNomina);
  const cantidadDiasIngresoFuturo = useSelector((state) => state.nomina.cantidadDiasIngresoFuturo);
  const [formModel, setFormModel] = useState(null);
  const [openAltaTempranaDialog, setOpenAltaTempranaDialog] = useState(false);
  const [attachedFile, setAttachedFile] = useState(null);
  const [pendingFormData, setPendingFormData] = useState(null);
  const [isAttachingFile, setIsAttachingFile] = useState(false);
  const dispatch = useDispatch();

  const handleCheckForFutureDate = (data) => {
    const fechaIngreso = moment(new Date(data.fechaIngresoEmpleador)).startOf('day').toDate();
    const today = moment(new Date()).startOf('day').toDate();
    if (fechaIngreso >= today) {
      setPendingFormData(data); // Guardo los datos del formulario hasta ese momento
      setOpenAltaTempranaDialog(true);
    } else {
      handleSubmit(data);
    }
  };

  const handleAttachFile = () => {
    const dataWithFile = {
      ...pendingFormData,
      ArchivoBase64: attachedFile[0]?.value
    };

    handleSubmit(dataWithFile); // Envío los datos del formulario + el archivo adjunto
    setOpenAltaTempranaDialog(false);
    setAttachedFile(null);
    setPendingFormData(null);
  };

  const handleCancelAttachment = () => {
    setOpenAltaTempranaDialog(false);
    setAttachedFile(null);
    setPendingFormData(null);
    setIsAttachingFile(false);
  };

  const handleSubmit = (data) => {
    const model = {
      ...data,
      fechaIngresoEmpleador: convertDateTimeToNet(data.fechaIngresoEmpleador),
      fechaIngresoDependencia: convertDateTimeToNet(
        data.fechaIngresoDependencia
      ),
      horaDesde: convertDateTimeToNet(data.horaDesde),
      horaHasta: convertDateTimeToNet(data.horaHasta),
      fechaBaja: convertDateTimeToNet(data.fechaBaja),
    };
    dispatch(saveDatosNominales(model));
    setLastFormSended();
  };

  useEffect(() => {
    if (cantidadDiasIngresoFuturo.data === 0) {
      dispatch(getCantidadDiasIngresoFuturoNomina());
    }
  }, []);

  useEffect(() => {
    if (nomina.data) {
      setFormModel(() => ({
        ...initialValues,
        domestica: nomina.data.domestica?.valor || initialValues.domestica,
        fechaIngresoEmpleador:
          nomina.data.fechaIngresoEmpleador?.valor ||
          initialValues.fechaIngresoEmpleador,
        categoriaDomestica:
          nomina.data.categoriaDomestica?.valor ||
          initialValues.categoriaDomestica,
        fechaIngresoDependencia:
          nomina.data.fechaIngresoDependencia?.valor ||
          initialValues.fechaIngresoDependencia,
        establecimiento:
          nomina.data.establecimiento?.valor || initialValues.establecimiento,
        puestoTrabajo:
          nomina.data.puestoTrabajo?.valor || initialValues.puestoTrabajo,
        turno: nomina.data.turno?.valor || initialValues.turno,
        horaDesde: nomina.data.horaDesde?.valor ? new Date(nomina.data.horaDesde.valor) : initialValues.horaDesde,
        horaHasta: nomina.data.horaHasta?.valor ? new Date(nomina.data.horaHasta.valor) : initialValues.horaHasta,
        bajaNomina: nomina.data.fechaBaja?.valor
          ? true
          : false || initialValues.bajaNomina,
        motivoBaja: nomina.data.motivoBaja?.valor || initialValues.motivoBaja,
        fechaBaja: nomina.data.fechaBaja?.valor || initialValues.fechaBaja,
      }));
    }
  }, [nomina.data]);
  return (
    <>
      {formModel != null ? (
        <DatosNominalesForm
          handleSubmit={handleCheckForFutureDate}
          model={formModel}
          fields={nomina.data}
          handleCancelNomina={handleCancelNomina}
          cantidadDiasIngresoFuturo={cantidadDiasIngresoFuturo.data}
          openAltaTempranaDialog={openAltaTempranaDialog}
          attachedFile={attachedFile}
          setAttachedFile={setAttachedFile}
          isAttachingFile={isAttachingFile}
          handleAttachFile={handleAttachFile}
          handleCancelAttachment={handleCancelAttachment}
        />
      ) : (
        <CircularLoading />
      )}
    </>
  );
};

export default DatosNominalesContainer;
